
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { useStore } from '@/store'
import QBtn from 'quasar/src/components/btn/QBtn.js';
import {
  modalOptionsExceededRateLimit,
  modalOptionsUpdateSucceed,
  modalTokenExpired,
} from '@/model/modal-options.model'
import { alertMessageOptionsOtherCaseError } from '@/model/alert-options.model'
import { StepEditMobile } from '@/model/step-edit-mobile.model'
import * as meService from '@/services/line-web-loyalty-bff/v1/me'

@Options({
  components: {
    QBtn,
  },
  computed: {
    customerList() {
      return this.$store.state.modalEditMobile.customerList
    },
  },
})
export default class CustomerList extends Vue {
  @Prop() getCustomerProfileFn!: (token: string) => void

  private store = useStore()
  private isSubmitting = false

  formatMobileNumber(phoneNumber: string) {
    return `0${phoneNumber.slice(2, phoneNumber.length)}`
  }

  async handleSubmit() {
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', true)
    this.isSubmitting = true

    const token = this.store.state.lineInfo.idToken

    if (token) {
      try {
        let requestBody: any = {}
        if (this.store.state.modalEditMobile.customerProfileDopa.length > 0) {
          requestBody = this.store.state.modalEditMobile.customerProfileDopa[0]
        }
        requestBody.l2_token = this.store.state.modalEditMobile.l2Token

        const result = await meService.updateMobileNumber(token, requestBody)

        const statusCode = result?.json?.code

        if (statusCode === 200) {
          this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)
          this.getCustomerProfileFn(token)
          this.store.commit('modalEditMobile/updateModalClose', true)
          this.store.commit('modalEditMobile/updateModalActive', false)
          this.store.dispatch(
            'modalNotification/onOpen',
            modalOptionsUpdateSucceed(this.store)
          )
        } else if (statusCode === 401) {
          const { error_name: errorName } = result?.json?.error
          if (errorName === 'token_expired') {
            this.store.dispatch(
              'modalNotification/onOpenTokenExpired',
              modalTokenExpired(() => {
                this.store.dispatch('modalNotification/onCloseTokenExpired')
                this.store.commit('modalEditMobile/updateStep', StepEditMobile.INPUT_NEW_MOBILE)
              })
            )
          } else {
            this.handleUnexpectedError()
          }
        } else if (statusCode === 429) {
          const { error_name: errorName } = result?.json?.error
          if (errorName === 'exceeded_rate_limit') {
            this.store.dispatch(
              'modalNotification/onOpen',
              modalOptionsExceededRateLimit(this.store)
            )
            this.store.dispatch('modalEditMobile/onClose')
          } else {
            this.handleUnexpectedError()
          }
        } else {
          this.handleUnexpectedError()
        }

        this.isSubmitting = false
      } catch (error) {
        this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)
        this.handleUnexpectedError()
        throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
      }
    }

    this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)
  }

  handleCancel() {
    this.store.commit('modalEditMobile/updateStep', StepEditMobile.INPUT_NEW_MOBILE)
  }

  handleUnexpectedError() {
    this.store.dispatch('alertMessage/onOpen', alertMessageOptionsOtherCaseError)
    setTimeout(() => this.store.dispatch('alertMessage/onClose'), 3000)
  }
}
